import { render, staticRenderFns } from "./StoresMovementMaster.vue?vue&type=template&id=5fc95b2e&scoped=true&"
import script from "./StoresMovementMaster.vue?vue&type=script&lang=js&"
export * from "./StoresMovementMaster.vue?vue&type=script&lang=js&"
import style0 from "./StoresMovementMaster.vue?vue&type=style&index=0&id=5fc95b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc95b2e",
  null
  
)

export default component.exports